import { render } from "./choosesubpart.vue?vue&type=template&id=1987bb6a"
import script from "./choosesubpart.vue?vue&type=script&lang=js"
export * from "./choosesubpart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__